module.exports = __webpack_public_path__ + "img/02.7a1b7aa0.jpg";